import { Link } from "react-router-dom";
import { useTranslator } from "../../context/translator";

const NoSpecialCategory = ({ description }) => {
  const { translate } = useTranslator();
  return (
    <div className="mt-4 p-4 rounded-lg bg-yellow-50 border border-yellow-200 flex items-start gap-4">
      <svg
        className="w-6 h-6 text-yellow-600 flex-shrink-0"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 8v4m0 4h.01M21 12A9 9 0 113 12a9 9 0 0118 0z"
        />
      </svg>

      <div>
        <h3 className="text-sm font-semibold text-yellow-800">
          {translate("no-categories-found")}
        </h3>

        <p className="mt-1 text-sm text-yellow-700">{description}</p>

        <div className="mt-3">
          <Link
            to="/clients/categories"
            className="inline-block px-3 py-1.5 text-sm font-medium rounded-md bg-yellow-600 text-white hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-yellow-500"
          >
            {translate("go-to-categories")}
          </Link>

          <Link
            to="/clients/categories"
            className="ml-3 text-sm underline text-yellow-700 hover:text-yellow-800"
          >
            {translate("manage-categories")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NoSpecialCategory;
